import AllChallengesButton from './AllChallengesButton';

export default AllChallengesButton;
